<template>
  <div class="cotti-modal" v-if="show" @click="popupHandler">
    <div class="cotti-modal-inner" v-if="!imgContent">
      <div v-if="title" class="title">{{title}}</div>
      <slot></slot>
      <div v-if="desc && desc !== ''" class="desc">{{desc}}</div>
      <div class="desc-list" v-if="descList.length > 0">
        <div v-for="(item, index) in descList" :key="index" class="desc-item">
           <span class="order-text"> {{index + 1}}. </span>
           <span class="desc-text">{{item}}</span>
        </div>
      </div>
      <div class="confirm-btn" @click.stop="confirmHandler">{{btnText}}</div>
    </div>
    <div class="adImg" v-else>
      <slot></slot>
    </div>
    <div class="cotti-modal-close" @click.stop="closeHandler">
      <img src="@/assets/pointsActivity/icon_close.png" alt="关闭">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CottiModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    descList: {
      type: Array,
      default: () => []
    },
    btnText: {
      type: String,
      default: '我知道了'
    },
    imgContent:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {}
  },
  methods: {
    confirmHandler() {
      this.$emit('onConfirm')
    },
    closeHandler() {
        this.$emit('onClose')
    },
    popupHandler() {
      if (this.closeOnClickOverlay) {
        this.closeHandler()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.cotti-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index:10;
  background-color: rgba(0, 0, 0, 0.55);

  .adImg{
    .adImgSize{
      width: 686px;
      height:auto;
      border-radius: 8px;
    }
  }

  &-inner {
    width: 510px;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 40px 48px 48px;
    .title{
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3A3B3C;
      line-height: 44px;
      margin-bottom: 40px;
    }
    .desc {
      text-align: justify;
      padding: 24px;
      background: #F5F5F5;
      border-radius: 8px;
      line-height: 34px;
      margin-bottom: 40px;
      color: #3A3B3C;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
    }
    .desc-list{
      text-align: justify;
      padding: 24px;
      background: #F5F5F5;
      border-radius: 8px;
      line-height: 34px;
      margin-bottom: 40px;
      .desc-item {
        margin: 4px 0;
        .order-text {
        color:#A52337;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }
      .desc-text {
        color: #3A3B3C;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }
      }
    }
    .confirm-btn {
      height: 80px;
      background: #A52337;
      box-shadow: 0 16px 24px -10px rgba(71,8,0,0.11), 0px 44px 16px -40px rgba(224,216,212,0.1);
      border-radius: 8px;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 80px;
    }
  }
  &-close{
    width: 64px;
    height: 64px;
    margin-top: 64px;
    >img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
